import React from 'react'
import styled from 'styled-components'
import { Box, Tabs } from '@ally/metronome-ui'
import { useWidget } from './WidgetContext'
import Buckets from './Buckets'
import Boosters from './Boosters'

export type TabName = 'Buckets' | 'Boosters'

const StyledTabsWrapper = styled(Box)`
  ${({ theme: { colors } }): string => `
  [data-reach-tabs] {
    margin-top: 0;
  }

  [data-reach-tab-list] {
      button {
        position: unset;
        height: auto;
        padding: 0;
        border: none;
        background-color: transparent;
        color: ${colors.bluesuedeshoes};
        font-weight: 700;

        &:first-of-type {
          margin-right: 30px;
        }

        &[data-selected] {
          color: ${colors.plum};
          border-bottom: 3px solid ${colors.plum};
        }
      }
    }

    [data-reach-tab-panel] {
      border: none;
      box-shadow: none;
      padding: 15px 0 0 0;
      background-color: transparent;
    }
  `};
`

const WidgetBody: React.FC = (): React.ReactElement => {
  const { stkSummaryData } = useWidget()
  const hasBuckets = stkSummaryData && stkSummaryData?.buckets.length > 1
  const hasBoosters = stkSummaryData && stkSummaryData?.boosters.length > 0
  const defaultTabIndex = !hasBuckets && hasBoosters ? 1 : 0
  const tabs: TabName[] = ['Buckets', 'Boosters']

  const itemsRef: HTMLElement[] = []

  const handleTabChange = (i: number): void => {
    itemsRef[i].focus()
  }

  const handleRef = (el: HTMLElement | null): number | null => {
    return el && itemsRef.push(el)
  }

  return (
    <Box textAlign="left" mb="xs" data-testid="stk-widget-body">
      <StyledTabsWrapper>
        <Tabs.Wrapper
          defaultIndex={defaultTabIndex}
          onChange={handleTabChange}
          suppressMdDownLayout
          mt="md"
        >
          <Tabs.TabWithPanel
            tab={tabs[0]}
            allytmln={`STK ${tabs[0]} Widget`}
            panel={<Buckets handleRef={handleRef} />}
          />
          <Tabs.TabWithPanel
            tab={tabs[1]}
            allytmln={`STK ${tabs[1]} Widget`}
            panel={<Boosters handleRef={handleRef} />}
          />
        </Tabs.Wrapper>
      </StyledTabsWrapper>
    </Box>
  )
}

export default WidgetBody
